module.exports = __webpack_public_path__ + "static/media/quicksandmedium.2eb64639.fnt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quicksandmedium.fnt
// module id = 156
// module chunks = 0